import { CreateElement } from 'vue'
import { Route, RouteConfig } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import * as TYPES from '@/helpers/enums/view-types'
import { NOTIFICATION_PAGES_ROUTES as ROUTES } from './utils'
import { lkNotificationPagePermissions as Permissions } from '@/helpers/enums/permission-models'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

export { MENU as MENU_NOTIFICATION_PAGES } from './utils'

const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'notification-pages',
    name: ROUTES.LAYOUT,
    redirect: { name: ROUTES.LIST },
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      const { registerModule } = await import(
        /* webpackChunkName: "form-data.store" */
        './store'
      )
      registerModule(options)
      next()
    },
    component: {
      name: 'view-notification-pages-layout',
      render: (h: CreateElement) => h('router-view'),
    },
    children: [
      {
        path: '',
        name: ROUTES.LIST,
        meta: {
          permission: [
            Permissions.read,
          ],
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "form-data.list" */
          './NotificationPagesList.vue'
        ),
      },
      {
        path: ':id(\\d+)',
        name: ROUTES.VIEW,
        meta: {
          permission: [
            Permissions.read,
          ],
        },
        props: ({ params: p }: Route) => ({ ...p, viewType: TYPES.VIEW }),
        component: (): PromiseVue => import(
          /* webpackChunkName: "form-data.view" */
          './NotificationPagesView.vue'
        ),
      },
      {
        path: ':id(\\d+)/edit',
        name: ROUTES.EDIT,
        meta: {
          permission: [
            Permissions.edit,
          ],
        },
        props: ({ params: p }: Route) => ({ ...p, viewType: TYPES.EDIT }),
        component: (): PromiseVue => import(
          /* webpackChunkName: "form-data.view" */
          './NotificationPagesView.vue'
        ),
      },
      {
        path: 'create',
        name: ROUTES.CREATE,
        meta: {
          permission: [
            Permissions.create,
          ],
        },
        props: () => ({ viewType: TYPES.CREATE }),
        component: (): PromiseVue => import(
          /* webpackChunkName: "form-data.view" */
          './NotificationPagesView.vue'
        ),
      },
    ],
  },
]

const createModule = (options: Options) => createRoutes(options)

export default createModule
